import { api } from './api'

export const pushApi = {
  key: () => api.get<{ key: string | null; configured: boolean; devices: number }>('/api/push/key'),
  subscribe: (subscription: PushSubscriptionJSON) =>
    api.post<{ ok: true; devices: number }>('/api/push/subscribe', { subscription }),
  unsubscribe: (endpoint: string) => api.post<{ ok: true; removed: number }>('/api/push/unsubscribe', { endpoint }),
  test: () => api.post<{ sent: number; dropped: number; failed: number; skipped?: string }>('/api/push/test'),
}

/**
 * iOS 只在「已添加到主屏」的 PWA 里给 Web Push。
 * Safari 标签页里 Notification 这个构造器根本不存在 —— 所以不能先弹授权框再失败，
 * 那样用户会以为是 App 坏了。必须先判断，再决定引导他去加桌面还是去授权。
 */
export function pushEnvironment(): 'ready' | 'need-install' | 'unsupported' {
  const standalone = window.matchMedia('(display-mode: standalone)').matches
    || (navigator as { standalone?: boolean }).standalone === true
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    // iOS Safari 标签页就是这一档：装到主屏之后同一台设备就会变成 ready
    return /iphone|ipad|ipod/i.test(navigator.userAgent) && !standalone ? 'need-install' : 'unsupported'
  }
  if (!('Notification' in window)) return standalone ? 'unsupported' : 'need-install'
  return 'ready'
}
